import React, { KeyboardEvent, MutableRefObject } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { ReactComponent as ArrowRight } from '../../icons/arrow-right-2.svg';

const IconWrapper = styled.div`
	width: 24px;
	height: 24px;

	svg {
		width: 24px;
		height: 24px;
		transform: rotate(180deg);
		margin-left: -8px;
		margin-right: 4px;

		path {
			stroke: ${theme.colorsV2.mainRed};
			stroke-width: 1.5px;
		}
	}
`;

const TextLink = styled.a<{
	$arrowLeft?: boolean;
}>`
	display: inline-flex;
	flex-direction: ${({ $arrowLeft }) => ($arrowLeft ? 'row-reverse' : 'row')};
	align-items: center;
	color: ${theme.colorsV2.mainRed};
	font-size: 16px;
	white-space: nowrap;
	transition: color 200ms ease, border-color 200ms ease;
	text-decoration: none;
	border-bottom-width: 1px;
	border-bottom-style: solid;
	border-color: transparent;

	&:last-of-type {
		margin-bottom: 0;
	}

	&:active {
		color: ${theme.colorsV2.lightRed};
	}

	${media.desktopSmall`
		cursor: pointer;
		&:hover {
			font-weight:  ${theme.fonts.weight.medium};
			border-color: ${theme.colorsV2.mainRed};
		}
	`}

	${IconWrapper} {
		margin-left: ${({ $arrowLeft }) => (!$arrowLeft ? '4px' : '-4px')};
		margin-right: ${({ $arrowLeft }) => ($arrowLeft ? '4px' : '-4px')};
	}
`;

type TProps = {
	href: string;
	title: string;
	target?: string | null;
	anchorRef?: MutableRefObject<HTMLAnchorElement | null>;
	role?: string;
	tabIndex?: number;
	arrowLeft?: boolean;
	className?: string;
	onKeyDown?: (event: KeyboardEvent) => void;
};

const TextLinkWithArrowReverse = ({
	href,
	title,
	target,
	anchorRef,
	role,
	tabIndex,
	arrowLeft = false,
	className,
	onKeyDown,
}: TProps) => {
	return (
		<TextLink
			{...(!href.startsWith('http') &&
				(!href.endsWith('pdf') || !href.endsWith('exe') || !href.endsWith('zip')) && { as: Link, to: href })}
			{...((href.startsWith('http') || href.endsWith('pdf') || href.endsWith('exe') || href.endsWith('zip')) && {
				href: href,
				target: target,
			})}
			aria-label={title}
			rel="noreferrer"
			ref={anchorRef}
			$arrowLeft={arrowLeft}
			role={role}
			tabIndex={tabIndex}
			onKeyDown={onKeyDown}
			className={className}>
			<IconWrapper>
				<ArrowRight />
			</IconWrapper>
			{title}
		</TextLink>
	);
};

export default TextLinkWithArrowReverse;
